import { render, staticRenderFns } from "./dev-param-form12.vue?vue&type=template&id=f2876aa0&scoped=true&"
import script from "./dev-param-form12.vue?vue&type=script&lang=js&"
export * from "./dev-param-form12.vue?vue&type=script&lang=js&"
import style0 from "./dev-param-form12.vue?vue&type=style&index=0&id=f2876aa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2876aa0",
  null
  
)

export default component.exports